import { getActiveChainId } from '../../config/active'

/** Cadena del catálogo de mercados (despliegue de la app, no la red de la wallet). */
export function useSwapCatalogChainId() {
  return getActiveChainId()
}
